import { css } from '@emotion/css';

import { AlignItems, Color, Display, Font, FontWeight, Spacing } from '../../styles';

export const tooltip = (text: 'underline' | 'none') => css`
  text-decoration: ${text};

  color: ${text === 'underline' ? Color.Brand6 : 'inherited'};

  &:hover {
    color: ${text === 'underline' ? Color.Brand6 : 'inherited'};
  }

  &:focus {
    color: ${text === 'underline' ? Color.Brand6 : 'inherited'};
  }
`;

export const overlay = css`
  .ant-tooltip-inner {
    ${Font.md}
  }
`;

export const popoverTitle = css`
  ${Display.inlineFlex}
  ${AlignItems.center}
  color: ${Color.Brand5};
  vertical-align: middle;
  cursor: pointer;
  ${Font.lg}
  ${FontWeight.normal}
`;

export const modalLabel = css`
  color: ${Color.Brand5};
  vertical-align: middle;
  cursor: pointer;
  ${Font.md}
  ${FontWeight.normal}
`;

export const icon = css`
  color: ${Color.Brand5};
  vertical-align: middle;
  cursor: pointer;
  ${Font.lg}
  ${FontWeight.normal}
  ${Spacing.ml4}
  ${Spacing.mr4}
`;
